import React, { useEffect, useRef, useState } from 'react'
import Form from './Form'
import Success from './Success'
import styles from '../ArtAdvisory.module.scss'
import classNames from 'classnames'

const ContactUsComponent = () => {
  const [state, handleState] = useState({
    isBlocking: false,
    hasCompleted: false,
    errorMessage: '',
  })
  const { hasCompleted } = state
  const contactUsRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    // setTimeout necessary to avoid layout shift and the link scroll to a wrong section
    setTimeout(() => {
      if (contactUsRef.current && location.href.includes('#contact-us')) {
        contactUsRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'center',
        })
      }
    }, 500)
  }, [])

  return (
    <div className={styles.contactUs}>
      <Success hasCompleted={hasCompleted} handleState={handleState} />
      <div
        ref={contactUsRef}
        className={classNames(
          {
            [styles.contactUsFormWrapperShow]: !hasCompleted,
          },
          styles.contactUsFormWrapper
        )}
        data-section='contact-us'
        id='contact-us'
      >
        <img
          className='lazyload'
          loading='lazy'
          width='700'
          height='824'
          data-src='//d3t95n9c6zzriw.cloudfront.net/art-advisory/contact-us.jpg'
          alt='Saatchi Art Advisory - Contact Us'
          itemProp='image'
        />

        <Form state={state} handleState={handleState} />
      </div>
    </div>
  )
}

export default ContactUsComponent
